
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TimeSlotSectionProps {
  timeSlots: string[];
  selectedTimeSlot: string | undefined;
  setTimeSlot: (slot: string) => void;
  dateSelected: boolean;
}

const TimeSlotSection: React.FC<TimeSlotSectionProps> = ({ 
  timeSlots, 
  selectedTimeSlot, 
  setTimeSlot, 
  dateSelected 
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Godzina montażu</h3>
      
      <div className="grid grid-cols-1 gap-2">
        {timeSlots.map((slot) => (
          <Button
            key={slot}
            type="button"
            variant={selectedTimeSlot === slot ? "default" : "outline"}
            className={cn(
              "justify-start h-12",
              selectedTimeSlot === slot ? "bg-primary text-white" : "bg-white"
            )}
            onClick={() => setTimeSlot(slot)}
            disabled={!dateSelected}
          >
            <div className="flex items-center">
              {selectedTimeSlot === slot && (
                <Check className="mr-2 h-4 w-4" />
              )}
              {slot}
            </div>
          </Button>
        ))}
      </div>
      
      <p className="text-sm text-gray-500 mt-4">
        Nasz zespół skontaktuje się z Tobą dzień przed montażem, aby potwierdzić wizytę.
      </p>
    </div>
  );
};

export default TimeSlotSection;
